export default "__VITE_ASSET__4856408c__"